<template>
  <div class="filter-container">
    <div class="card col-12 p-0">
      <div class="card-body">
        <div class="actions d-flex flex-wrap flex-auto tablenav">
          <DatePicker v-model="query.date" :preset-dates="presetDates" range multi-calendars format="YYYY-MM-DD" class="m-1 date-picker-left" placeholder="Date Range" style="max-width: 250px" />
          <Select class="m-1 has-tip" :options="statisticOptions" placeholder="Statistic" data-title="Statistic" v-model="query.statistic"></Select>
          <Select class="m-1 has-tip" source="user/search" type="auto" field="all" placeholder="User" data-title="User" v-model="query.user_id"></Select>
          <button class="m-1 btn btn-light" @click.prevent="submit">Search</button>
        </div>
      </div>
    </div>

    <div class="card main-card">
      <div class="no-gutters row">
        <template v-for="(statusObject, status, index) in listStatus" :key="status">
          <div v-if="total[`status_${status}`]" class="col-12 col-md-6 col-lg-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">{{ statusObject.label }}</div>
                </div>
                <div class="widget-content-right">
                  <div :class="`widget-numbers ${styles[index % styles.length].text}`">
                    {{ statusNumber(total[`status_${status}`]) }}
                  </div>
                </div>
              </div>
              <div class="widget-progress-wrapper">
                <div class="progress-bar-sm progress-bar-animated-alt progress">
                  <div :class="`progress-bar ${styles[index % styles.length].progressbar}`" :style="`width:${statusPercent(total[`status_${status}`])}%`"></div>
                </div>
                <div class="progress-sub-label">
                  <div class="sub-label-left">0%</div>
                  <div class="sub-label-right">100%</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue'
import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      query: {
        date: [moment(new Date()).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')],
        account_id: '',
        user_id: ''
      },
      totalNumber: null,
      styles: [
        {
          text: 'text-warning',
          progressbar: 'bg-warning'
        },
        {
          text: 'text-danger',
          progressbar: 'bg-danger'
        },
        {
          text: 'text-primary',
          progressbar: 'bg-primary'
        },
        {
          text: 'text-success',
          progressbar: 'bg-success'
        }
      ],
      presetDates: ['Today', 'Yesterday', 'This Week', 'Last Week', '7 Days Ago', 'This Month', 'Last Month', '30 Days Ago', '3 Months Ago', '90 Days Ago', 'This Year']
    }
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    total() {
      return this.extraAttributes?.all || {}
    },
    listStatus() {
      return Object.fromEntries(
        Object.entries(Object.assign({}, this.extraAttributes.status)).sort(([, a], [, b]) => {
          return (a.priority || 10) - (b.priority || 10)
        })
      )
    },
    statisticOptions() {
      return Object.values(
        this.$util.map(this.extraAttributes.statistic, ({ item, key }) => {
          return {
            id: key,
            text: item.label
          }
        })
      )
    },
    freehandManufactureOptions() {
      return Object.values(
        this.$util.map(this.extraAttributes.freehand_design, ({ item, key }) => {
          return {
            id: key,
            text: item.label
          }
        })
      )
    }
  },
  props: {
    config: Object
  },
  methods: {
    statusNumber(object) {
      return object.number || 0
    },
    statusPercent(object) {
      let number = this.statusNumber(object)
      if (this.totalNumber === null) {
        this.totalNumber = this.$util.reduce(this.total, ({ item, next }) => {
          return next + item.number
        })
      }
      return Math.round((number * 100) / this.totalNumber)
    },
    submit() {
      this.query.search = ''
      this.$emit('change-filters', this.query, { refresh: true, goToFirst: true })
    }
  }
}
</script>
<style lang="scss">
.page-manufacture-statistic {
  .filter-container {
    > .card {
      margin-bottom: 20px;
    }
  }
}
</style>
